import React, { useEffect, useState, useRef } from "react";
import { connect } from "react-redux";
import PubSub from "pubsub-js";
import {
  House,
  ChevronRight,
  ChevronDown,
  ChevronsUpDown,
  ExternalLink,
  MessageCircle,
  Mail,
} from "lucide-react";
import { getUrlParams } from "@/utils";

import { withRouter } from "react-router-dom";
import { map } from "lodash";
import {
  Layout,
  Menu,
  Dropdown,
  Spin,
  Select,
  Button,
  Popover,
  Input,
  Modal,
  message,
  Tooltip,
  Divider,
  Progress,
} from "antd";
import {
  CopyOutlined,
  MenuFoldOutlined,
  MenuUnfoldOutlined,
} from "@ant-design/icons";
import { getFlowSsoUrl } from "@/api/viralContent";

import type { MenuProps } from "antd";
import RouterList from "./routerList";
import Language from "@/components/Common/Language";
import {
  login,
  logout,
  getUserInfo,
  getEnvCheck,
  getInfo,
  updateInfo,
} from "@/actions/auth";
import dayjs from "dayjs";
import { Cookie } from "@/utils/cookie";
import Login from "../Login/Login";
import TkauthRedirect from "../common/TkauthRedirect";
import TkauthVideoRedirect from "../common/TkauthVideoRedirect";
import Register from "../Register/Register";
import Password from "../Password/Password";
import MobileInvite from "../MobileInvite/MobileInvite";
import copyBatch from "@/utils/copy";
import XunfeiAi from "../XunfeiAi";
import logo from "@/assets/image/logo.png";
import home1 from "@/assets/image/home1.png";
import home2 from "@/assets/image/home2.png";
import warning1 from "@/assets/image/menu/warning1.png";
import warning2 from "@/assets/image/menu/warning2.png";
import warnPng from "@/assets/image/warn.png";
import successPng from "@/assets/image/success.png";
import leftlogo from "@/assets/image/leftlogo.png";
import logImg from "@/assets/image/logImg1.png";
import vip from "@/assets/image/vip.png";
import shopIcon from "@/assets/image/shopIcon.png";
import header1 from "@/assets/image/header1.png";
import header2 from "@/assets/image/header2.png";
import header3 from "@/assets/image/header3.png";
import ercode from "@/assets/image/ercode.png";
import homePageErcode from "@/assets/image/homePageErcode.jpg";
import { menuMapData, menu } from "@/utils/menuMap";
import LogContainer from "../../components/Supplier/LogContainer";
import { selectShop } from "@/api/shop";

import styles from "./index.module.scss";

import "./index.scss";
import intl from "react-intl-universal";

const { Header, Content, Footer, Sider } = Layout;

const { Option } = Select;
const MenuLayout = ($$) => {
  // 左侧菜单相关参数
  const [collapsed, setCollapsed] = useState(false);
  const [showModal, setShowModal] = useState(false);
  const [contentLeftMargin, setContentLeftMargin] = useState(250);
  const [selectedKeys, setSelectedKeys] = useState([]);
  const [isModalVisible, setIsModalVisible] = useState(false);
  const [defaultOpenKeys, setDefaultOpenKeys] = useState([]);
  const [selecObj, setSelecObj] = useState<any>("");
  const [showShopList, setShowShopList] = useState(false);
  const [selectShopInfo, setSelectShopInfo] = useState<any>({});
  const [showChangeModal, setShowChangeModal] = useState(false);
  const [changeLoading, setChangeLoading] = useState(false);
  const [showShop, setShowShop] = useState(false);
  const [contactUsVisible, setContactUsVisible] = useState(false);
  const [hiddenMenu, setHiddenMenu] = useState(false);

  // 新增：用于存储 shopList 的引用
  const shopListRef = useRef(null);
  const hasAuth =
    $$.currentMerchantShop?.isTkAuth === 1 &&
    $$.currentMerchantShop?.isReady === 1;
  const hasExpired =
    !$$?.endTime || dayjs(`${$$.endTime} 23:59:59`).isBefore(dayjs());

  useEffect(() => {
    const isIndependent = sessionStorage.getItem("isIndependent");
    const paramsIsIndependent = getUrlParams("isIndependent");
    const state = getUrlParams("state");
    const stateData = JSON.parse(decodeURIComponent(state || "{}") || "{}");

    if (paramsIsIndependent === "1" || stateData?.isIndependent === "1") {
      sessionStorage.setItem("isIndependent", "1");
    }
    if (
      paramsIsIndependent === "1" ||
      isIndependent === "1" ||
      stateData?.isIndependent === "1"
    ) {
      setHiddenMenu(true);
      toggleSideBar();
    }

    const data = sessionStorage.getItem("firstModal");
    if (!data) {
      // setIsModalVisible(true);
      sessionStorage.setItem("firstModal", "1");
    }
  }, []);

  // 新增：监听全局点击事件，判断是否点击在 shopList 外部
  useEffect(() => {
    const handleClickOutside = (event) => {
      if (shopListRef.current && !shopListRef.current.contains(event.target)) {
        setShowShopList(false);
      }
      setShowShop(false);
    };

    document.addEventListener("mousedown", handleClickOutside);
    return () => {
      document.removeEventListener("mousedown", handleClickOutside);
    };
  }, []);

  // set selectedKeys and defaultOpenKeys 根据path获取高亮和展开的节点
  const setSelectedNodeInfo = (menuList) => {
    if (menuList && menuList.length > 0) {
      menuList.forEach((item) => {
        if (item.path === window.location.pathname && item.parentId) {
          setSelecObj({
            title: intl.get(
              menuMapData(item.key || item.path)?.title || "null",
            ),
          });
          setSelectedKeys([`${item.id}`]);
          setDefaultOpenKeys([`${item.parentId}`]);
          return;
        }
        // if (pathname.includes(item.path) && !item.parentId) {
        //   setSelectedKeys([`${item.id}`]);
        //   return;
        // }
        setSelectedNodeInfo(item.children);
      });
    }
  };

  const toggleSideBar = () => {
    setCollapsed(!collapsed);
    setContentLeftMargin(collapsed ? 250 : 0);
  };

  const pageCompontent = {
    "/login": <Login />,
    "/tkauth-redirect": <TkauthRedirect />,
    "/tkauth-video-redirect": <TkauthVideoRedirect />,
    "/register": <Register />,
    "/password": <Password />,
    "/mobileInvite": <MobileInvite />,
  };

  // mounted
  useEffect(() => {
    if (Cookie.get("token") && !pageCompontent[window.location.pathname]) {
      $$.getUserInfo();
      $$.getEnvCheck();
    } else if (!pageCompontent[window.location.pathname]) {
      window.location.href = "/login";
    } else {
      // do
    }
  }, []);

  // listen menuList data and pathname change
  useEffect(() => {
    // setDefaultOpenKeys(
    //   $$.menuList.map((menuListitem) => String(menuListitem.id)),
    // );
    if (window.location.pathname === "/envconfig") {
      setSelecObj({ title: intl.get("menuLayout_title") });
      setSelectedKeys([`envconfig`]);
      return;
    }
    // if (window.location.pathname === "/warning") {
    //   setSelecObj({ title: intl.get("sample_hignBtnTip") });
    //   setSelectedKeys([`warning`]);
    //   return;
    // }
    if ($$.menuList.length > 0) {
      // set active node and open nodes

      setSelectedNodeInfo($$.menuList);
    }
  }, [$$.menuList, window.location.pathname]);

  useEffect(() => {
    PubSub.subscribe("TK_CHECK_ENV_RESULT", (_msg, data) => {
      if (data?.data.hasLogin) {
        $$.getEnvCheck();
      }
    });

    return () => {
      PubSub.unsubscribe("TK_CHECK_ENV_RESULT");
    };
  }, []);

  const onUserActionClick = (key) => {
    switch (key) {
      case "logout":
        $$.logout();
        break;
      case "invitation":
        setShowModal(true);
        break;
      default:
        break;
    }
  };

  const changeShop = async (id, name) => {
    setChangeLoading(true);
    const res = await selectShop({ id });
    if (res.code === 200) {
      message.success(`${intl.get("menuLayout_shop")}${name}`);
      $$.getInfo();
      setTimeout(() => {
        setChangeLoading(false);
        window.location.reload();
      }, 1000);
    }
  };

  const onMenuItemClick = (id, _parentIdList, path, type, obj) => {
    // type - 菜单类型
    const { history } = $$;

    if (window.location.pathname === path) return;

    // 如果点击分组菜单-不跳转
    if (type === 3) return;
    setSelecObj({
      title: intl.get(menuMapData(obj.key || obj.path)?.title || "null"),
    });
    history.push(path);

    setSelectedKeys([`${id}`]);

    // 解决内部跳转 点击菜单返回主页问题
    if (window.location.pathname.indexOf(path) === 0) {
      history.push("/");
      setTimeout(() => {
        history.replace(path);
      });
    }
  };

  const renderUserAction = () => {
    const { nickname, invitationCode } = $$;
    const items: MenuProps["items"] = [
      {
        key: "4",
        label: (
          <div
            onClick={() => {
              $$.history.push("/mine");
            }}
          >
            {intl.get("menuLayout_account")}
          </div>
        ),
      },
      {
        key: "2",
        label: (
          <div onClick={() => onUserActionClick("invitation")}>
            {intl.get("menuLayout_invit")}
          </div>
        ),
      },
      {
        key: "1",
        label: (
          <div onClick={() => onUserActionClick("logout")}>
            {intl.get("menuLayout_logout")}
          </div>
        ),
      },
    ];

    return (
      <div className="user-view">
        <button
          className={styles.bannerBtn}
          onClick={async () => {
            try {
              const res = await getFlowSsoUrl({
                nextPath: "/app/flow",
              });
              if (res.code === 200) {
                window.open(res.data.redirectUrl, "_blank");
              }
            } catch (error) {
            } finally {
            }
          }}
        >
          <ExternalLink className={styles.btnIcon} />
          <span>Go to 95Flow</span>
        </button>
        <div
          className={styles.inviteView}
          onClick={() => {
            onUserActionClick("invitation");
          }}
        >
          {intl.get("menuLayout_invite")}
          <span>{intl.get("menuLayout_rebate")}</span>
        </div>

        <div className={styles.headerIcon}>
          <img
            src={header1}
            alt=""
            onClick={() => {
              setContactUsVisible(true);
            }}
          />
        </div>
        {/* <div
          className={styles.headerIcon}
          onClick={() => {
            window.open(
              "https://scnspbynpgwz.feishu.cn/wiki/NLHJwWpyqiif0jkTWO7cj7Xxnvg?from=from_copylink",
              "_blank",
            );
          }}
        >
          <img src={header2} alt="" />
        </div> */}
        {/* <div className={styles.headerIcon}>
          <Language dom={<img src={header3} alt="" />} />
        </div> */}

        <Dropdown
          menu={{
            items: [
              ($$.isTryout === 1 || $$.isWhiteList === 1) && $$.endTime
                ? {
                    key: "3",
                    label: (
                      <div style={{ color: "red" }}>
                        {intl.get("menuLayout_end")}
                        {$$.endTime}
                      </div>
                    ),
                  }
                : null,
              ...items,
            ],
          }}
          trigger={["click"]}
        >
          <span className="user-action">
            <img src={logo} alt="" />
            <span>{nickname || "***"} </span>
            <span>{`(${$$.email})`}</span>
          </span>
        </Dropdown>
      </div>
    );
  };

  const renderMenuList = (menuList) => {
    return map(menuList, (m) => {
      if (["/envconfig"].includes(m.path)) {
        return null;
      }
      if (m.subMenu.length === 0) {
        const IconComponent = menuMapData(m.key || m.path)?.iconComponent;
        return (
          <Menu.Item
            key={m.id}
            onClick={() => {
              if (
                (!hasAuth &&
                  ![2, 31, 43, 44, 45, 46].includes(m.id) &&
                  m.parentId !== 40) ||
                (hasExpired && ![2, 43, 44, 45, 46, 82].includes(m.id))
              ) {
                return;
              }
              onMenuItemClick(m.id, m.parentIdList, m.path, m.type, m);
            }}
            style={
              (!hasAuth &&
                ![2, 31, 43, 44, 45, 46].includes(m.id) &&
                m.parentId !== 40) ||
              (hasExpired && ![2, 43, 44, 45, 46].includes(m.id))
                ? {
                    filter: "grayscale(100%)",
                    cursor: "no-drop",
                  }
                : {}
            }
          >
            {IconComponent ? (
              <IconComponent
                size={16}
                color={
                  selectedKeys.indexOf(String(m.id)) === -1
                    ? "#6b7280"
                    : "#1677ff"
                }
              />
            ) : null}

            <span>
              {intl.get(menuMapData(m.key || m.path)?.title || "null")}
            </span>
          </Menu.Item>
        );
      }
      const ParentIconComponent = menuMapData(m.key || m.path)?.iconComponent;
      return (
        <Menu.SubMenu
          key={m.id}
          title={
            <span
              style={{
                width: "100%",
                height: "36px",
                display: "flex",
                alignItems: "center",
                justifyContent: "space-between",
              }}
              onClick={() => {
                if (
                  defaultOpenKeys.length &&
                  defaultOpenKeys.includes(String(m.id))
                ) {
                  setDefaultOpenKeys([]);
                } else {
                  setDefaultOpenKeys([String(m.id)]);
                }
              }}
            >
              <span style={{ fontSize: "13px" }}>
                {ParentIconComponent ? (
                  <ParentIconComponent
                    size={16}
                    color={
                      selectedKeys.indexOf(String(m.id)) === -1
                        ? "#6b7280"
                        : "#1677ff"
                    }
                  />
                ) : null}
                {intl.get(menuMapData(m.key || m.path)?.title || "null")}
              </span>
              {defaultOpenKeys.includes(String(m.id)) ? (
                <ChevronDown size={15} color="#6b7280b3" />
              ) : (
                <ChevronRight size={15} color="#6b7280b3" />
              )}
            </span>
          }
        >
          {renderMenuList(m.subMenu)}
        </Menu.SubMenu>
      );
    });
  };

  const { menuList, location, systemLoading } = $$;

  if (systemLoading && window.location.pathname !== "/login") {
    return (
      <div className="system-loading-wrapper">
        <Spin size="large" />
      </div>
    );
  }

  return (
    <>
      {pageCompontent[window.location.pathname] ? (
        pageCompontent[window.location.pathname]
      ) : (
        <Layout
          className={`menu-layout ${
            location.pathname.split("/").length > 0
              ? location.pathname.split("/")[1]
              : ""
          } ${styles.homeContent}`}
        >
          <Sider
            className="sidebar"
            trigger={null}
            collapsible
            collapsed={collapsed}
            width={250}
            collapsedWidth={0}
          >
            <div className="logo-wrapper">
              <img src={leftlogo} alt="" />
              {$$.currentMerchantShop?.shopId && (
                <div className={styles.shopViewBox}>
                  <Select
                    suffixIcon={<ChevronsUpDown size={12} color="#6b7280" />}
                    className={styles.keyOptionviewSelect}
                    placeholder={intl.get("envConfig_selectShopOwner")}
                    // open={showShop}
                    // onClick={() => {
                    //   setShowShop(!showShop);
                    // }}
                    onChange={(e, data: any) => {
                      if (e === $$.currentMerchantShop?.id) {
                        return;
                      }
                      console.log(data);
                      setSelectShopInfo({
                        id: e,
                        name: `${data.children}`,
                      });
                      setShowChangeModal(true);
                    }}
                    value={$$.currentMerchantShop?.id}
                    labelRender={(propValue) => {
                      const item = $$?.shopList.find((item) => {
                        return item.id === propValue.value;
                      });
                      return (
                        <div className={styles.selectLableView}>
                          <span className={styles.countryName}>
                            <p>{item?.shopName[0]}</p>
                            <div>
                              <div>{item?.shopName}</div>
                              {$$.packageName && <span>{$$.packageName}</span>}
                            </div>
                          </span>

                          {/* {item?.shopName} */}
                        </div>
                      );
                    }}
                    popupRender={(menu) => (
                      <>
                        {menu}
                        <Divider style={{ margin: "8px 0" }} />
                        <div>
                          <Button
                            className={styles.manageShops}
                            onClick={() => {
                              $$.history.push("/shopList");
                            }}
                          >
                            Manage shops
                          </Button>
                        </div>
                      </>
                    )}
                  >
                    {$$?.shopList.map((item) => {
                      return (
                        <Option key={item.id} value={item.id}>
                          {item.shopName}
                        </Option>
                      );
                    })}
                  </Select>
                </div>
              )}
            </div>
            <div className="menu-wrapper">
              <div className="env-box">
                {$$.email && (
                  <div
                    className={`env-menu ${
                      selectedKeys.indexOf("envconfig") !== -1 &&
                      "env-menu-select"
                    }`}
                    onClick={() => {
                      setSelecObj({ title: intl.get("menuLayout_title") });
                      setSelectedKeys([`envconfig`]);
                      $$.history.push("/envconfig");
                    }}
                  >
                    <House
                      size={16}
                      color={
                        selectedKeys.indexOf("envconfig") === -1
                          ? "#6b7280"
                          : "#1677ff"
                      }
                    />
                    <div>
                      {intl.get("menuLayout_title")}
                      {hasAuth ? (
                        <span className="success">
                          <img src={successPng} alt="" />
                        </span>
                      ) : (
                        <span className="warn">
                          <img src={warnPng} alt="" />
                        </span>
                      )}
                    </div>
                  </div>
                )}
              </div>

              {/* {menuList.findIndex((item) => item.path === "/warning") !==
                -1 && (
                <div className="env-box" style={{ padding: " 0 8px" }}>
                  <div
                    className={`env-menu ${styles.warningView} ${
                      selectedKeys.indexOf("warning") !== -1 &&
                      styles.warningSelect
                    }`}
                    style={
                      !hasAuth || hasExpired
                        ? {
                            filter: "grayscale(100%)",
                            cursor: "no-drop",
                          }
                        : {}
                    }
                    onClick={() => {
                      if (!hasAuth || hasExpired) return;
                      setSelecObj({ title: intl.get("sample_hignBtnTip") });
                      setSelectedKeys([`warning`]);
                      $$.history.push("/warning");
                    }}
                  >
                    <img className={styles.warning1} src={warning1} alt="" />
                    <div style={{ display: "block" }}>
                      <div className={styles.titleView}>
                        {intl.get("sample_hignBtnTip")}
                      </div>
                      <span className={styles.titleBtn}>
                        {intl.get("homepage_warning_btn")}→
                      </span>
                    </div>
                    <div className={styles.warning2}>
                      <img src={warning2} alt="" />
                    </div>
                    <span className={styles.warningTitleTip}>
                      {intl.get("homepage_anti_abuse")}
                    </span>
                  </div>
                </div>
              )} */}
              {!collapsed && (
                <Menu
                  // theme="dark"
                  style={{ height: "calc(100% - 210px)" }}
                  mode="inline"
                  openKeys={defaultOpenKeys}
                  selectedKeys={selectedKeys}
                >
                  {renderMenuList(menuList)}
                </Menu>
              )}
            </div>
            {$$.packageName && (
              <div className={styles.planInfo}>
                <div className={styles.planInfoContent}>
                  <p className={styles.planInfoText}>
                    {$$.packageName} <span>{$$.remainingDays}d left</span>
                  </p>
                  <Progress
                    percent={
                      !$$.remainingDays
                        ? 100
                        : ($$.remainingDays / $$.totalDays) * 100
                    }
                    showInfo={false}
                    size={{ height: 4 }}
                  />
                  <div
                    className={styles.planInfoUpgrade}
                    onClick={() => {
                      $$.history.push("/package");
                    }}
                  >
                    Upgrade plan →
                  </div>
                </div>
              </div>
            )}
          </Sider>

          <Layout
            className="right-section"
            style={{ marginLeft: contentLeftMargin }}
          >
            <Header
              className="header"
              style={{ display: hiddenMenu ? "none" : "block" }}
            >
              <div className="headerLeft">
                <div onClick={toggleSideBar}>
                  {collapsed ? <MenuUnfoldOutlined /> : <MenuFoldOutlined />}
                </div>

                <span className="title">{selecObj.title || selecObj.name}</span>
              </div>

              {renderUserAction()}
            </Header>

            <Content
              className={`npm-package-content ${
                $$.logShow && "npm-package-content-show"
              }`}
              style={{ marginTop: hiddenMenu ? "0" : "56px" }}
            >
              <div
                className={`${styles.leftContainer} ${
                  $$.logShow && styles.leftContainerShow
                }`}
              >
                <RouterList
                  userId={$$.id}
                  userName={$$.userName}
                  length={$$.menuList.length}
                  menuList={$$.menuList}
                  history={$$.history}
                />
              </div>

              <div
                className={`${styles.logContainer} ${
                  $$.logShow && styles.logContainerShow
                }`}
              >
                <div className={styles.title}>
                  {intl.get("menuLayout_systemLog")}
                  <span
                    onClick={() => {
                      $$.updateInfo({
                        logShow: false,
                      });
                    }}
                  >
                    {intl.get("menuLayout_sq")}
                  </span>
                </div>
                {$$.id && (
                  <div className={styles.logContent}>
                    <LogContainer getInfo={$$.getInfo} />
                  </div>
                )}
              </div>
              {/* <Tooltip
                color={"#fff"}
                placement="left"
                title={
                  <>
                    <img style={{ width: 200 }} src={homePageErcode} alt="" />
                    <p
                      style={{
                        color: "rgba(0, 0, 0,0.45)",
                        fontSize: "14px",
                        textAlign: "center",
                      }}
                    >
                      {intl.get("menuLayout_vipText")}
                    </p>
                  </>
                }
                trigger="click"
              >
                <div className={styles.logVipView}>
                  <img src={vip} alt="" />
                  {intl.get("menuLayout_vip")}
                </div>
              </Tooltip> */}

              {/* {!$$.logShow && (
                
              )} */}
              {/* <div
                className={styles.logTipView}
                onClick={() => {
                  $$.updateInfo({
                    logShow: $$.logShow ? false : true,
                  });
                }}
              >
                <img src={logImg} alt="" />
                {intl.get("menuLayout_taskLog")}
              </div> */}
              {/* <XunfeiAi userId={$$.id} userName={$$.userName} /> */}
            </Content>

            {/* <Footer className="footer">
              Copyright ©{new Date().getFullYear()} 95AI管理系统
            </Footer> */}
          </Layout>
          <Modal
            centered
            open={showModal}
            width={400}
            onCancel={() => setShowModal(false)}
            onOk={() => setShowModal(false)}
          >
            <>
              {intl.get("menuLayout_invite_tip")}
              <br />
              {intl.get("menuLayout_invite_tip1")}
              <br />
              <Input
                readOnly
                allowClear
                value={`${window.location.origin}/register?code=${$$.invitationCode}`}
                suffix={
                  <>
                    <CopyOutlined
                      style={{ cursor: "pointer" }}
                      onClick={() => {
                        copyBatch(
                          `${window.location.origin}/register?code=${$$.invitationCode}`,
                        );
                      }}
                    />
                  </>
                }
              />
            </>
          </Modal>
          <Modal
            // title="达人评分高级配置"
            open={isModalVisible}
            centered
            onCancel={() => {
              setIsModalVisible(false);
            }}
            footer={null}
            width={800}
          >
            <div className={styles.modalContent}>
              <div className={styles.title}>
                {intl.get("index_modal_title")}
              </div>
              <p className={styles.desc}>{intl.get("index_modal_desc")}</p>
              <div className={styles.tip}>{intl.get("index_modal_desc1")}</div>
              <ul>
                <li>{intl.get("index_modal_desc2")}</li>
                <li>{intl.get("index_modal_desc3")}</li>
                <li>{intl.get("index_modal_desc4")}</li>
              </ul>
              <p className={styles.tip}>{intl.get("index_modal_desc5")}</p>
              <p className={styles.tip}>{intl.get("index_modal_desc6")}</p>
            </div>
          </Modal>

          <Modal
            title={intl.get("common_http_title")}
            width={700}
            open={showChangeModal}
            onCancel={() => {
              setShowChangeModal(false);
            }}
            destroyOnClose
            centered
            afterClose={() => {
              setSelectShopInfo({});
            }}
            confirmLoading={changeLoading}
            onOk={() => {
              changeShop(selectShopInfo.id, selectShopInfo.name);
            }}
          >
            <div>Confirm to switch stores?</div>
          </Modal>

          <Modal
            open={contactUsVisible}
            centered
            onCancel={() => {
              setContactUsVisible(false);
            }}
            footer={null}
            width={448}
            title="Contact Us"
          >
            <div className={styles.contactUsDesc}>
              Reach the operations or technical team.
            </div>
            <div className={styles.contactUsTitle}>
              <MessageCircle color="#3c83f6" size={16} />
              Operations (WhatsApp)
            </div>
            <div className={styles.contactUsErcode}>
              <img src={ercode} alt="" />
            </div>
            <div className={styles.contactUsImgDesc}>
              Scan to chat with operations on WhatsApp
            </div>
            <div className={styles.contactUsTitle}>
              <Mail color="#3c83f6" size={16} />
              Technical Support
            </div>
            <div className={styles.contactUsEmail}>95support@9five.cn</div>
          </Modal>
        </Layout>
      )}
    </>
  );
};

const mapStateToProps = (state) => {
  const {
    nickname,
    id,
    menuList,
    systemLoading,
    invitationCode,
    applicationInstalled,
    tiktokMerchantLoginStatus,
    email,
    currentMerchantShop,
    shopList,
    logShow,
    isTryout,
    isWhiteList,
    endTime,
    packageName,
    remainingDays,
    totalDays,
  } = state.auth;
  return {
    nickname,
    id,
    menuList,
    systemLoading,
    invitationCode,
    applicationInstalled,
    tiktokMerchantLoginStatus,
    email,
    currentMerchantShop,
    shopList,
    logShow,
    isTryout,
    isWhiteList,
    endTime,
    packageName,
    remainingDays,
    totalDays,
  };
};

export default withRouter(
  connect(mapStateToProps, {
    login,
    logout,
    getUserInfo,
    getEnvCheck,
    getInfo,
    updateInfo,
  })(MenuLayout),
);
